import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { GameProvider } from './context/GameContext';
import { OnboardingProvider } from './context/OnboardingContext';
import { LanguageProvider } from './context/LanguageContext';
import ProtectedRoute from './components/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop';
import { useGoogleAnalytics } from './hooks/useGoogleAnalytics';
import LoginPage from './pages/auth/LoginPage';
import SignUpPage from './pages/auth/SignUpPage';
import Dashboard from './pages/Dashboard';
import OnboardingPage from './pages/OnboardingPage';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import AssetsPage from './pages/AssetsPage';
import Stocks from './pages/Stocks';
import EtfIndicesPage from './pages/EtfIndicesPage';
import CryptoETFPage from './pages/CryptoETFPage';
import BondETFPage from './pages/BondETFPage';
import MobileFinancialPage from './pages/MobileFinancialPage';
import GroupRankingsPage from './pages/GroupRankingsPage';
import ChatPage from './pages/ChatPage';
import SettingsPage from './pages/SettingsPage';
import './i18n/config';
import './App.css';
import './styles/visualization-dark-mode.css';
import './styles/enhanced-portfolio-chart.css';
import { ThemeProvider } from './hooks/useTheme';

// Google Analytics tracker component
const GoogleAnalyticsTracker = () => {
  useGoogleAnalytics();
  return null;
};

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <LanguageProvider>
          <OnboardingProvider>
            <GameProvider>
              <Router>
              <ScrollToTop />
              <GoogleAnalyticsTracker />
          <div className="App">
            <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignUpPage />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/onboarding" element={
              <ProtectedRoute>
                <OnboardingPage />
              </ProtectedRoute>
            } />
            <Route path="/portfolio" element={<Navigate to="/dashboard" replace />} />
            <Route path="/assets" element={
              <ProtectedRoute>
                <AssetsPage />
              </ProtectedRoute>
            } />
            <Route path="/stocks" element={
              <ProtectedRoute>
                <Stocks />
              </ProtectedRoute>
            } />
            <Route path="/etf-indices" element={
              <ProtectedRoute>
                <EtfIndicesPage />
              </ProtectedRoute>
            } />
            <Route path="/crypto-etfs" element={
              <ProtectedRoute>
                <CryptoETFPage />
              </ProtectedRoute>
            } />
            <Route path="/bond-etfs" element={
              <ProtectedRoute>
                <BondETFPage />
              </ProtectedRoute>
            } />
            <Route path="/learn" element={<Navigate to="/dashboard" replace />} />
            <Route path="/mobile/financial" element={
              <ProtectedRoute>
                <MobileFinancialPage />
              </ProtectedRoute>
            } />
            <Route path="/groups/:groupId" element={
              <ProtectedRoute>
                <GroupRankingsPage />
              </ProtectedRoute>
            } />
            <Route path="/groups" element={
              <ProtectedRoute>
                <GroupRankingsPage />
              </ProtectedRoute>
            } />
            <Route path="/join-group/:groupCode" element={
              <ProtectedRoute>
                <GroupRankingsPage />
              </ProtectedRoute>
            } />
            <Route path="/chat" element={
              <ProtectedRoute>
                <ChatPage />
              </ProtectedRoute>
            } />
            <Route path="/settings" element={
              <ProtectedRoute>
                <SettingsPage />
              </ProtectedRoute>
            } />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </div>
            </Router>
          </GameProvider>
        </OnboardingProvider>
      </LanguageProvider>
    </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
